var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeHidden = function SvgEyeHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 19,
    fill: "none",
    viewBox: "0 0 30 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M.99 16.99L28.813 1.223"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.476 8.262a23.214 23.214 0 00-7.003-5.046 18.052 18.052 0 00-15.274 0A23.216 23.216 0 00.196 8.262a.695.695 0 000 .968A23.219 23.219 0 007.2 14.276c2.394 1.108 5 1.686 7.638 1.694a18.315 18.315 0 007.636-1.694 23.213 23.213 0 007.004-5.046.695.695 0 000-.968zm-14.64 6.318c-4.722 0-9.26-2.015-13.16-5.834 3.9-3.82 8.438-5.835 13.16-5.835 4.722 0 9.26 2.015 13.16 5.835-3.9 3.82-8.438 5.834-13.16 5.834zm-4.43-5.834a4.43 4.43 0 108.858 0 4.43 4.43 0 00-8.858 0zm4.43-3.04a3.04 3.04 0 110 6.08 3.04 3.04 0 010-6.08z"
  })));
};
export default SvgEyeHidden;